import { useEffect, useState, useCallback } from "react";
import { Send, MessageSquare } from "lucide-react";
import { api } from "../lib/api";
import { fmtDateTime } from "./constants";

export default function AdminMessages() {
  const [convos, setConvos] = useState(null);
  const [active, setActive] = useState(null);
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");

  useEffect(() => {
    api.get("/admin/conversations").then((r) => setConvos(r.data)).catch(() => setConvos([]));
  }, []);

  const openThread = useCallback((c) => {
    setActive(c);
    api.get(`/admin/messages/${c.id}`).then((r) => setMessages(r.data)).catch(() => setMessages([]));
  }, []);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim() || !active) return;
    const { data } = await api.post(`/admin/messages/${active.id}`, { body });
    setMessages((prev) => [...prev, data]);
    setBody("");
  };

  return (
    <div data-testid="admin-messages-page" className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-[#0A192F]">Messaggi</h1>
        <p className="mt-1 text-slate-600">Conversazioni con i clienti.</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="rounded-2xl border border-slate-200 bg-white lg:col-span-1">
          <div className="border-b border-slate-200 px-5 py-3 text-xs font-bold uppercase tracking-wide text-slate-500">Clienti</div>
          <div className="max-h-[60vh] overflow-y-auto">
            {convos === null ? (
              <p className="py-10 text-center text-slate-400">Caricamento...</p>
            ) : convos.length === 0 ? (
              <p className="py-10 text-center text-sm text-slate-400">Nessuna conversazione.</p>
            ) : (
              convos.map((c) => (
                <button key={c.id} data-testid={`admin-convo-${c.id}`} onClick={() => openThread(c)}
                  className={`flex w-full flex-col items-start gap-0.5 border-b border-slate-100 px-5 py-4 text-left transition-colors last:border-0 ${active?.id === c.id ? "bg-[#10B981]/5" : "hover:bg-slate-50"}`}>
                  <span className="font-semibold text-[#0A192F]">{c.name}</span>
                  <span className="line-clamp-1 text-xs text-slate-500">{c.last_message || "Nessun messaggio"}</span>
                </button>
              ))
            )}
          </div>
        </div>

        <div className="flex flex-col rounded-2xl border border-slate-200 bg-white lg:col-span-2">
          {!active ? (
            <div className="flex flex-1 flex-col items-center justify-center py-20 text-slate-400">
              <MessageSquare className="h-10 w-10" />
              <p className="mt-3 text-sm">Seleziona un cliente per vedere la conversazione.</p>
            </div>
          ) : (
            <>
              <div className="border-b border-slate-200 px-5 py-3">
                <p className="font-semibold text-[#0A192F]">{active.name}</p>
                <p className="text-xs text-slate-500">{active.email}</p>
              </div>
              <div className="flex-1 space-y-3 overflow-y-auto p-5" style={{ maxHeight: "50vh" }}>
                {messages.length === 0 ? (
                  <p className="py-6 text-center text-sm text-slate-400">Nessun messaggio.</p>
                ) : (
                  messages.map((m) => (
                    <div key={m.id} data-testid={`admin-thread-msg-${m.id}`} className={`flex ${m.from_staff ? "justify-end" : "justify-start"}`}>
                      <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 text-sm ${m.from_staff ? "bg-[#10B981] text-white" : "bg-slate-100 text-slate-800"}`}>
                        <p>{m.body}</p>
                        <p className={`mt-1 text-[10px] ${m.from_staff ? "text-white/70" : "text-slate-400"}`}>{m.from_staff ? "Staff" : active.name} · {fmtDateTime(m.created_at)}</p>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <form onSubmit={send} className="flex items-center gap-3 border-t border-slate-200 p-4">
                <input data-testid="admin-thread-input" value={body} onChange={(e) => setBody(e.target.value)} placeholder="Scrivi al cliente..." className="flex-1 rounded-full border border-slate-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#10B981]" />
                <button data-testid="admin-thread-send" className="flex h-10 w-10 items-center justify-center rounded-full bg-[#10B981] text-white transition-colors hover:bg-[#059669]"><Send className="h-5 w-5" /></button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
